import axios from "axios";

// Load API URL from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL;
// console.log("API Document URL:", process.env.REACT_APP_API_URL);

export const createDocument = async (title, content, token) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/documents`,
      { title, content },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data; // Return response data for further processing
  } catch (error) {
    console.error("Error creating document:", error);
    throw error; // Re-throw the error to handle it in the component
  }
};
